import {combineReducers} from 'redux';
import types from './types';

const INITIAL_STATE = {type: '', title: '', context: [], open: false, action: ''};

// 通信中
const isRequesting = (state = false, action) => {
  switch (action.type) {
    case types.START_REQUEST:
      return true;
    case types.END_REQUEST:
      return false;
    default:
      return state;
  }
};

// メッセージダイアログ
const dialogInfo = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.OPEN_DIALOG:
      return action.dialogInfo;
    case types.CLOSE_DIALOG:
      // 高優先度のメッセージを閉じた際、高優先度フラグを削除
      if (state.hasOwnProperty('highPriority')) {
        delete state.highPriority;
      }
      return {...state, open: false};
    default:
      return state;
  }
};

// モーダル
const modalInfo = (state = {btnExist: false, open: false}, action) => {
  switch (action.type) {
    case types.OPEN_MODAL:
      return action.modalInfo;
    case types.CLOSE_MODAL:
      return {btnExist: false, open: false};
    default:
      return state;
  }
};

// アクセス時間情報
const checkAccess = (state = {time: null}, action) => {
  switch (action.type) {
    case types.CHECK_ACCESS:
      return action.accessInfo;
    default:
      return state;
  }
};

// GETパラメータ
const getParam = (state = {time: null}, action) => {
  switch (action.type) {
    case types.GET_PARAM:
      return action.getParam;
    default:
      return state;
  }
};

// 汎用マスタ
const generalPurposeMap = (state = null, action) => {
  switch (action.type) {
    case types.GET_ALL_GENERAL_PURPOSE_MAP:
      return action.generalPurposeMap;
    default:
      return state;
  }
};

// 担当者マスタID 設定
const contactId = (state = null, action) => {
  switch (action.type) {
    case types.SET_CONTACT_ID:
      return action.contactId;
    default:
      return state;
  }
};

// 画面の参照状態 設定
const referenceMode = (state = null, action) => {
  switch (action.type) {
    case types.SET_REFERENCE_MODE:
      return action.referenceMode;
    default:
      return state;
  }
};

// 警告メッセージ設定
const setGmnWarning = (state = null, action) => {
  switch (action.type) {
    case types.SET_GMN_WARNING:
      let data = state ? state : {};
      if (action.warning == false) {
        if (action.Id in data) {
          delete data[action.Id];
        }
      } else {
        data[action.Id] = action.warning;
      }
      return data;

    default:
      return state;
  }
};

// 初期値
const setInitValues = (state = null, action) =>{
  switch (action.type) {
    case types.SET_INIT_VALUES:
      return action.initValues;
    default:
      return state;
  }
};


// ログイン時刻の保持
const loginTime = (state = null, action) =>{
  switch (action.type) {
    case types.SET_LOGIN_TIME:
      return action.loginTime;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isRequesting,
  dialogInfo,
  modalInfo,
  checkAccess,
  getParam,
  generalPurposeMap,
  contactId,
  referenceMode,
  setGmnWarning,
  setInitValues,
  loginTime,
});

export default reducer;
